import React, { useEffect, useState } from 'react'

import { useLocation } from 'react-router-dom'

import { ResponseEmailCard } from 'components'

import errorImg from 'images/error.svg'
import CheckImage from 'images/check.svg'

import * as service from 'service'

const ConsentEmailConfirmed = () => {
  const location = useLocation()
  const [error, setError] = useState(null)

  const queryParams = new URLSearchParams(location.search)
  const token = queryParams.get('token')

  useEffect(() => {
    if (!token) return

    const confirmEmail = async () => {
      try {
        await service.dponet.consent.confirmStatus({ token })
      } catch (error) {
        console.error('Erro ao confirmar o e-mail:', error)
        setError(error)
      }
    }

    confirmEmail()
  }, [token])

  const errorMessage = error?.response?.data?.error?.message

  return (
    <>
      {error ? (
        <ResponseEmailCard
          text="Houve um erro ao confirmar seu e-mail. Por favor, tente novamente."
          content={errorMessage || 'Houve um erro inesperado.'}
          img={errorImg}
        />
      ) : (
        <ResponseEmailCard
          text="Seu e-mail foi confirmado com sucesso!"
          img={CheckImage}
        />
      )}
    </>
  )
}

export default ConsentEmailConfirmed
